import { render, staticRenderFns } from "./DynamsoftBarcodeScanner.vue?vue&type=template&id=22f3f50b"
import script from "./DynamsoftBarcodeScanner.vue?vue&type=script&lang=ts"
export * from "./DynamsoftBarcodeScanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports